import React, {useEffect, useState} from 'react';
import OptionalMenu from '../../../components/optional-menu/optional-menu';
import {optionalMenuOptions} from '../optional-menu-items';
import {Route, Routes, useNavigate} from "react-router-dom";
import {actions, Control, Form} from "react-redux-form";
import CustomInput from "../../../components/custom-input/custom-input";
import {useTranslation} from "react-i18next";
import {Button} from "@material-ui/core";
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import LineWeightIcon from '@material-ui/icons/LineWeight';
import {Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import {getEmails, getPhones, postCommunicationStatus} from "../../../services/settings.service";
import {AppState} from "../../../store/store";
import {connect, useDispatch} from "react-redux";
import MotbusOptionView from "./modbus";
import {IrdaSettings} from "./irda-settings";
import {updateNames} from "../../../services/state";
import {getRelaysNames, getAllNames} from "../../../services/names.service";
import {setDataInStore} from "../../../utils/setDataInStore";
import Loader from "react-loader-spinner";
import {GeneralOptionView} from "./general-settings";

interface PhonesProps {
    phone: string;
    name: string;
}

interface IPhoens {
    sim: string;
    phones: PhonesProps[]
}

const initialPhones = {
    sim: '',
    phones: []
}

interface IPureOptionViewPhones {
    state: AppState
}

const PureOptionViewPhones: React.FC<IPureOptionViewPhones> = (props) => {
    const [modal, setModal] = useState(false);
    const [loading, setLoading] = useState(true);
    const toggle = () => setModal(!modal);
    const {t} = useTranslation();
    const [phones, setPhones] = useState<IPhoens>(initialPhones);
    const dispatch = useDispatch();
    const handleSubmit = (data: any) => {
        postCommunicationStatus({
            phones: {
                sim: data.sim,
                phones: phones.phones.filter((phone) => phone.phone !== '')
            }
        })
    }
    useEffect(() => {
        getPhones().then(
            (res) => {
                dispatch(actions.change('phones' + '.sim', res.sim));
                setPhones({
                    sim: res.sim,
                    phones: res.phones.filter((phone: any) => phone.phone !== '')
                });
                setLoading(false);
            }
        ).catch(() => setLoading(false))
    }, []);
    const handleSubmitModal = (data: any) => {
        setPhones({
            sim: phones.sim,
            phones: [...phones.phones, {
                name: data.tmpName,
                phone: data.tmpPhone
            } ]
        })
        dispatch(actions.change(phones + '.tmpName', ''));
        dispatch(actions.change(phones + '.tmpPhone', ''));
        toggle();
    }
    const removePhone = (indexToRemove: number) => {
        setPhones({
            sim: phones.sim,
            phones: phones.phones.filter((phone, index) => index !== indexToRemove)
        });
    }
    if (!loading) {
        return (
            <div className='d-flex justify-content-center w-100 align-items-start router-container'>
                <div className='card default-card'>
                    <div className="card-body">
                        <div className='card-title-container'>
                            <span className='card-title'>{t('phones')}</span>
                        </div>
                        <Form
                            model='phones'
                            onSubmit={(phones) => handleSubmit(phones)}>
                            {/* <div className='option-name-row'>
                                <div className='option-main-row'>
                                    <Control
                                        model='.sim'
                                        component={CustomInput}
                                        label={t('sim')}
                                        id={'.sim'}/>
                                </div>
                            </div> */}
                            <div className='d-flex justify-content-between option-name-row'>
                                <div>{t('phoneUsers')}</div>
                                <Button variant="outlined" type='button' color="primary" onClick={toggle}>
                                    {t('add')}
                                </Button>
                            </div>
                            <div className='option-name-row'>
                                <table className="table text-center">
                                    <thead>
                                    <tr>
                                        <th scope="col">{t('phone')}</th>
                                        <th scope="col">{t('usernames')}</th>
                                        <th scope="col">{t('actions.delete')}</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {
                                        phones.phones.map((phone, index) => <tr>
                                            <td>{phone.phone}</td>
                                            <td>{phone.name}</td>
                                            <td className='d-flex justify-content-center'>
                                                {/*<div className='default-action-icon'><LineWeightIcon/></div>*/}
                                                <div className='default-action-icon' onClick={() => removePhone(index)}><HighlightOffIcon/></div>
                                            </td>
                                        </tr>)
                                    }
                                    </tbody>
                                </table>
                            </div>
                            <div className='modal-action-row'>
                                <Button variant="contained" type='submit' color="primary" className='modal-default-button'>
                                    {t('save')}
                                </Button>
                            </div>
                        </Form>
                    </div>
                </div>
                <Modal isOpen={modal} toggle={toggle}>
                    <Form model='phones'
                          onSubmit={(phones) => handleSubmitModal(phones)}>
                        <ModalHeader toggle={toggle}>{t('addPhone.title')}</ModalHeader>
                        <ModalBody className='d-flex justify-content-around'>
                            <div className='d-flex justify-content-around w-100'>
                                <div className='default-field'>
                                    <Control
                                        model='.tmpPhone'
                                        component={CustomInput}
                                        defaultValue=''
                                        label={t('phone')}/>
                                </div>
                                <div className='default-field'>
                                    <Control
                                        model='.tmpName'
                                        component={CustomInput}
                                        defaultValue=''
                                        label={t('usernames')}/>
                                </div>
                            </div>
                        </ModalBody>
                        <ModalFooter>
                            <Button variant="outlined" color="primary" type='submit'>{t('save')}</Button>
                        </ModalFooter>
                    </Form>
                </Modal>
            </div>
        )
    }
    return <div className='w-100 d-flex justify-content-center pt-5'>
        <Loader
            type="Puff"
            color="#555374"
            height={100}
            width={100}
            timeout={3000} //3 secs

        />
    </div>;
}
const mapStateToProps = (state: AppState) => ({
    state: state
});

interface IEmail {
    email: string;
    name: string;
}


const OptionViewPhones = connect(mapStateToProps)(PureOptionViewPhones);
const OptionViewEmails: React.FC = () => {
    const [modal, setModal] = useState(false);
    const [loading, setLoading] = useState(true);
    const toggle = () => setModal(!modal);
    const dispatch = useDispatch();
    const {t} = useTranslation();
    const [emails, setEmails] = useState<IEmail[]>([]);
    useEffect(() => {
        getEmails().then(
            (res) => {
                setEmails(res.emails.filter((email: any) => email.email !== ''));
                dispatch(actions.change('emails.adminEmail', res.adminEmail));
                setLoading(false);
            }
        ).catch(() => setLoading(false))
    }, []);
    const handleSubmit = (data: any) => {
        postCommunicationStatus({
            emails: emails.filter((email) => email.email !== ''),
            mainEmail: data.adminEmail || ''
        })
    }
    const handleSubmitModal = (data: any) => {
        setEmails([...emails, {
            name: data.tmpName,
            email: data.tmpEmail
        }])
        dispatch(actions.change(emails + '.tmpName', ''));
        dispatch(actions.change(emails + '.tmpPhone', ''));
        toggle();
    }
    const removeEmail = (indexToRemove: number) => {
        setEmails(emails.filter((email, index) => index !== indexToRemove));
    }
    if (!loading) {
        return (
            <div className='d-flex justify-content-center w-100 align-items-start router-container'>
                <div className='card default-card'>
                    <div className="card-body">
                        <div className='card-title-container'>
                            <span className='card-title'>{t('emailsTitle')}</span>
                        </div>
                        <Form
                            model='emails'
                            onSubmit={(data) => handleSubmit(data)}>
                            <div className='option-name-row'>
                                <div className='option-main-row'>
                                    <Control
                                        model='.adminEmail'
                                        component={CustomInput}
                                        id={'.adminEmail'}/>
                                </div>
                            </div>
                            <div className='d-flex justify-content-between option-name-row'>
                                <div>{' '}</div>
                                <Button variant="outlined" type='button' color="primary" onClick={toggle}>
                                    {t('add')}
                                </Button>
                            </div>
                            <div className='option-name-row'>
                                <table className="table text-center">
                                    <thead>
                                    <tr>
                                        <th scope="col">{t('usernames')}</th>
                                        <th scope="col">{t('email')}</th>
                                        <th scope="col">{t('actions.delete')}</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {
                                        emails.map((email, index) => <tr>
                                            <td>{email.name}</td>
                                            <td>{email.email}</td>
                                            <td className='d-flex justify-content-center'>
                                                {/*<div className='default-action-icon'><LineWeightIcon/></div>*/}
                                                <div className='default-action-icon' onClick={() => removeEmail(index)}><HighlightOffIcon/></div>
                                            </td>
                                        </tr>)
                                    }
                                    </tbody>
                                </table>
                            </div>
                            <div className='modal-action-row'>
                                <Button variant="contained" type='submit' color="primary" className='modal-default-button'>
                                    {t('save')}
                                </Button>
                            </div>
                        </Form>
                    </div>
                </div>
                <Modal isOpen={modal} toggle={toggle}>
                    <Form model='emails'
                          onSubmit={(emails) => handleSubmitModal(emails)}>
                        <ModalHeader toggle={toggle}>{t('addMail.title')}</ModalHeader>
                        <ModalBody className='d-flex justify-content-around'>
                            <div className='d-flex justify-content-around w-100'>
                                <div className='default-field'>
                                    <Control
                                        model='.tmpEmail'
                                        component={CustomInput}
                                        defaultValue=''
                                        label={t('email')}/>
                                </div>
                                <div className='default-field'>
                                    <Control
                                        model='.tmpName'
                                        component={CustomInput}
                                        defaultValue=''
                                        label={t('usernames')}/>
                                </div>
                            </div>
                        </ModalBody>
                        <ModalFooter>
                            <Button variant="outlined" color="primary" type='submit'>{t('save')}</Button>
                        </ModalFooter>
                    </Form>
                </Modal>
            </div>
        )
    }
    return <div className='w-100 d-flex justify-content-center pt-5'>
        <Loader
            type="Puff"
            color="#555374"
            height={100}
            width={100}
            timeout={3000} //3 secs

        />
    </div>;
}

const OptionViewNames: React.FC = () => {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        getAllNames().then(
            (res) => {
                setDataInStore(dispatch, res, 'names');
                setLoading(false)
            }
        ).catch(() => setLoading(false))
    })
    const handleSubmit = (names: any) => {
        updateNames(names);
    }
    if (!loading) {
        return (
            <div className='d-flex justify-content-center w-100 align-items-start router-container'>
                <div className='card default-card w-100'>
                    <div className="card-body">
                        <div className='card-title-container'>
                            <span className='card-title'>{t('names')}</span>
                        </div>
                        <Form
                            model='names'
                            onSubmit={(names) => handleSubmit(names)}>
                            <div className='d-flex flex-wrap justify-content-center ml-auto'>
                                <div className='card default-small-card card-name'>
                                    <div className="card-body">
                                        <div className='text-center mb-3'>{t('relays')}</div>
                                        <div className='d-flex flex-column justify-content-around'>
                                            {
                                                [1, 2, 3, 4, 5].map((item) => <div
                                                    className='default-field default-row-in-column'>
                                                    <Control
                                                        model={'.relays.relay' + item}
                                                        component={CustomInput}
                                                        label={'Przekaźnik ' + item}/>
                                                </div>)
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className='card default-small-card card-name ml-auto'>
                                    <div className="card-body">
                                        <div className='text-center mb-3'>{t('irda')}</div>
                                        <div className='d-flex flex-column justify-content-around flex-grow-1'>
                                            {
                                                [1, 2, 3, 4].map((item) => <div
                                                    className='default-field default-row-in-column'>
                                                    <Control
                                                        model={'.irda.irda' + item}
                                                        component={CustomInput}
                                                        label={'Irda ' + item}/>
                                                </div>)
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className='d-flex flex-column ml-auto'>
                                    <div className='card default-small-card card-name'>
                                        <div className="card-body">
                                            <div className='text-center mb-3'>{t('humidity')}</div>
                                            <div className='d-flex flex-column justify-content-around'>
                                                {
                                                    [1].map((item) => <div
                                                        className='default-field default-row-in-column'>
                                                        <Control
                                                            model={'.humidity.humidity' + item}
                                                            component={CustomInput}
                                                            label={'Wilgotność ' + item}/>
                                                    </div>)
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    <div className='card default-small-card card-name'>
                                        <div className="card-body">
                                            <div className='text-center mt-3 mb-3'>{t('inputsAndOutputsAnalog')}</div>
                                            <div className='d-flex flex-column justify-content-around'>
                                                {
                                                    [1].map((item) => <div
                                                        className='default-field default-row-in-column'>
                                                        <Control
                                                            model={'.analogs.analog' + item}
                                                            component={CustomInput}
                                                            label={'Wyjście analogowe ' + item}/>
                                                    </div>)
                                                }
                                                {
                                                    [2].map((item) => <div
                                                        className='default-field default-row-in-column'>
                                                        <Control
                                                            model={'.analogs.analog' + item}
                                                            component={CustomInput}
                                                            label={'Wejście analogowe ' + item}/>
                                                    </div>)
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='card default-small-card card-name ml-auto'>
                                    <div className="card-body">
                                        <div className='text-center mb-3'>{t('temperatures')}</div>
                                        <div className='d-flex flex-column justify-content-around'>
                                            {
                                                [1, 2, 3, 4, 5, 6].map((item) => <div
                                                    className='default-field default-row-in-column'>
                                                    <Control
                                                        model={'.temperature.temp' + item}
                                                        component={CustomInput}
                                                        defaultValue={'t' + item}
                                                        label={'Temperatura ' + item}/>
                                                </div>)
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className='card default-small-card card-name ml-auto'>
                                    <div className="card-body">
                                        <div className='text-center mb-3'>{t('inputs-title')}</div>
                                        <div className='d-flex flex-column justify-content-around'>
                                            {
                                                [1, 2, 3, 4, 5, 6].map((item) => <div
                                                    className='default-field default-row-in-column'>
                                                    <Control
                                                        model={'.inputs.input' + item}
                                                        component={CustomInput}
                                                        label={'Wejście ' + item}/>
                                                </div>)
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='modal-action-row'>
                                <Button variant="contained" type='submit' color="primary" className='modal-default-button'>
                                    {t('save')}
                                </Button>
                            </div>
                        </Form>
                    </div>
                </div>
            </div>
        )
    }
    return <div className='w-100 d-flex justify-content-center pt-5'>
        <Loader
            type="Puff"
            color="#555374"
            height={100}
            width={100}
            timeout={3000} //3 secs

        />
    </div>;
}

const OptionsView: React.FC = () => {
    const navigate = useNavigate();
    const handleChangeOptionKey = (key: string) => {
        navigate(key);
    }
    return (
        <div className='d-flex w-100'>
            <OptionalMenu {...optionalMenuOptions} onChange={handleChangeOptionKey}/>
            <Routes>
                <Route path="phones" element={<OptionViewPhones/>}/>
                <Route path="email" element={<OptionViewEmails/>}/>
                <Route path="name" element={<OptionViewNames/>}/>
                <Route path="modbus" element={<MotbusOptionView/>}/>
                <Route path="irda-settings" element={<IrdaSettings/>}/>
                <Route path="general" element={<GeneralOptionView/>}/>
            </Routes>
        </div>
    )
}

export default OptionsView;